import renderMagicLink from './render';

export default (uuid: string): void => {
  if (window.PGWidgets && window.PGWidgets.actions.openMagicLinkModal) {
    renderMagicLink(uuid);
  } else {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = `${process.env.MONOLITH_HOST_URL}/widgets.js?async=true&bundle_name=magicLink`;
    script.async = true;
    script.onload = () => renderMagicLink(uuid);
    document.head.appendChild(script);
  }
};
